var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.26 10.422c.245.197-2.253 8.929-2.597 8.929-.172 0-3.4-.85-6.648-.85-3.235 0-6.492.85-6.692.85-.401 0-2.787-8.83-2.587-8.929.2-.098 3.766 1.915 4.352 1.915.586 0 4.192-7.722 4.905-7.688.714.035 4.104 7.688 4.906 7.688.801 0 4.114-2.111 4.36-1.915Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export default SvgCrown;